/** Vibecode authoring notes for `grid` nodes (empty = omit from LLM bundle). */
export const GRID_VIBECODE = [
  '`grid`: `variant` compact|default|loose; `gap` overrides row gap only (column gutter from variant when cols≥2).',
  'Use inside `card` for field columns — not side-by-side macro cards (use `flex` row+wrap).',
].join('\n');
